// extracted by mini-css-extract-plugin
export default {"wrap":"sMeSRKAH","wrapWithGroup":"tUHXhNoH","title":"HDd_vtxs"};